(() => {
  'use strict';

  const ENDPOINT = 'https://drjuviwon-macmini.tailef3689.ts.net/events/shopify/journey';
  const SESSION_KEY = 'drj_journey_session_id';
  const SESSION_TOUCH_KEY = 'drj_journey_session_touch';
  const SESSION_TTL = 30 * 60 * 1000;
  const ATTRIBUTION_COOKIE = 'drj_journey_attribution';
  const path = window.location.pathname;
  const productMatch = path.match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
  if (!productMatch) return;

  const storageGet = (key) => {
    try { return window.localStorage?.getItem(key) || ''; } catch { return ''; }
  };
  const storageSet = (key, value) => {
    try { window.localStorage?.setItem(key, value); } catch {}
  };
  const cookieGet = (name) => {
    const match = document.cookie.split('; ').find((item) => item.startsWith(`${name}=`));
    return match ? decodeURIComponent(match.slice(name.length + 1)) : '';
  };
  const cookieSet = (name, value) => {
    document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=1800; SameSite=Lax; Secure`;
  };

  const startedAt = Date.now();
  let sessionId = storageGet(SESSION_KEY) || cookieGet(SESSION_KEY);
  const lastTouch = Number(storageGet(SESSION_TOUCH_KEY) || startedAt);
  if (!/^j_[A-Za-z0-9_-]{20,80}$/.test(sessionId) || startedAt - lastTouch > SESSION_TTL) {
    const random = window.crypto?.randomUUID?.().replaceAll('-', '')
      || `${startedAt.toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
    sessionId = `j_${random}`;
    storageSet(SESSION_KEY, sessionId);
  }
  storageSet(SESSION_KEY, sessionId);
  storageSet(SESSION_TOUCH_KEY, String(startedAt));
  cookieSet(SESSION_KEY, sessionId);

  const params = new URLSearchParams(window.location.search);
  const attributionKey = `drj_journey_attribution_${sessionId}`;
  let prior = {};
  try { prior = JSON.parse(storageGet(attributionKey) || cookieGet(ATTRIBUTION_COOKIE) || '{}'); } catch {}
  let referrerHost = '';
  try { referrerHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch {}
  const attribution = {
    utm_source: params.get('utm_source') || prior.utm_source || '',
    utm_medium: params.get('utm_medium') || prior.utm_medium || '',
    utm_campaign: params.get('utm_campaign') || prior.utm_campaign || '',
    utm_content: params.get('utm_content') || prior.utm_content || '',
    referrer_host: referrerHost || prior.referrer_host || '',
  };
  attribution.traffic_source = params.has('fbclid')
    || /^(facebook|instagram|meta)$/i.test(attribution.utm_source)
    || /(?:facebook|instagram)\.com$/i.test(attribution.referrer_host)
    ? 'meta'
    : (attribution.utm_source || prior.traffic_source || 'direct');
  storageSet(attributionKey, JSON.stringify(attribution));
  cookieSet(ATTRIBUTION_COOKIE, JSON.stringify(attribution));

  const locale = (document.documentElement.lang || path.split('/')[1] || '').slice(0, 10).toLowerCase();
  const productHandle = decodeURIComponent(productMatch[1]).toLowerCase();
  let sequence = 0;
  const send = (eventName, properties = {}) => {
    const event = {
      event_id: `browser:${sessionId.slice(2, 18)}:${startedAt}:${sequence += 1}:${eventName}`,
      session_id: sessionId,
      event_name: eventName,
      occurred_at: new Date().toISOString(),
      shop_domain: 'dr-juviwon-2.myshopify.com',
      locale,
      page_path: path,
      product_handle: productHandle,
      ...attribution,
      properties,
    };
    fetch(ENDPOINT, {
      method: 'POST', mode: 'cors', keepalive: true,
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(event),
    }).catch(() => {});
  };

  fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
    method: 'POST', credentials: 'same-origin',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ attributes: {
      _journey_session_id: sessionId,
      _journey_locale: locale,
      _journey_page_path: path,
      _journey_product_handle: productHandle,
      _journey_traffic_source: attribution.traffic_source,
      _journey_utm_source: attribution.utm_source,
      _journey_utm_medium: attribution.utm_medium,
      _journey_utm_campaign: attribution.utm_campaign,
      _journey_utm_content: attribution.utm_content,
    } }),
  }).catch(() => {});

  send('product_view', { viewport_width: window.innerWidth });

  let gallerySent = false;
  const gallerySelector = 'media-gallery,.product__media-wrapper,.product__media-list,[id^="Slider-Gallery"],.swiper,[data-product-media-gallery]';
  const controlSelector = '.slider-button,.swiper-button-next,.swiper-button-prev,.thumbnail,[data-media-id],[data-product-thumbnail]';
  const galleryEngaged = (method) => {
    if (gallerySent) return;
    gallerySent = true;
    send('gallery_engaged', { method });
  };
  document.addEventListener('click', (event) => {
    const control = event.target.closest(controlSelector);
    if (control && (control.closest(gallerySelector) || document.querySelector(gallerySelector)?.contains(control))) {
      galleryEngaged('control');
    }
  }, { capture: true, passive: true });
  let pointerStart = null;
  document.addEventListener('pointerdown', (event) => {
    if (event.target.closest(gallerySelector)) pointerStart = { x: event.clientX, y: event.clientY };
  }, { passive: true });
  document.addEventListener('pointerup', (event) => {
    if (!pointerStart) return;
    if (Math.abs(event.clientX - pointerStart.x) >= 30 || Math.abs(event.clientY - pointerStart.y) >= 30) {
      galleryEngaged('swipe');
    }
    pointerStart = null;
  }, { passive: true });

  const reached = new Set();
  const checkScroll = () => {
    const total = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    const percent = Math.min(100, Math.round((window.scrollY / total) * 100));
    for (const threshold of [25, 50, 75, 100]) {
      if (percent >= threshold && !reached.has(threshold)) {
        reached.add(threshold);
        send(`scroll_${threshold}`, { depth_percent: threshold });
      }
    }
  };
  window.addEventListener('scroll', checkScroll, { passive: true });
  window.addEventListener('pagehide', checkScroll, { passive: true });
  checkScroll();
})();
